import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@capturum/auth';
import { AuthPageBase } from '../base/auth-page-base.class';
import { take } from 'rxjs/operators';
import { LoginAction } from '../base/login-action.enum';
import { LoginConfigService } from '../login-config.service';
import { Observable } from 'rxjs';
import { LoginConfig } from '../login.config';
import { ValidatorService } from '@capturum/ui/api';
import { CapturumActivationService } from '../services/activation.service';

@Component({
    selector: 'cap-activation',
    templateUrl: './activation.component.html',
    styleUrls: ['./activation.component.scss'],
    standalone: false
})
export class ActivationComponent extends AuthPageBase implements OnInit {
  public action = LoginAction.activation;
  public config$: Observable<LoginConfig>;
  private token: string;

  constructor(
    protected readonly validatorService: ValidatorService,
    private readonly activationService: CapturumActivationService,
    private readonly route: ActivatedRoute,
    private readonly configService: LoginConfigService,
    private readonly authService: AuthService,
  ) {
    super(validatorService);

    this.config$ = this.configService.getConfig();
    this.form = this.activationService.getForm();
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.route.params.pipe(take(1)).subscribe((params) => {
      if (params.token) {
        this.token = params.token;
      }

      if (params.email) {
        this.form.patchValue({ email: params.email });
        this.form.get('email').disable();
        this.form.get('email').updateValueAndValidity();
      }
    });
  }

  public submit(): void {
    if (this.form.invalid) {
      this.markAsTouched();
      return;
    }

    this.authService.activate({ token: this.token, ...this.form.getRawValue() })
      .subscribe(
        (response) => this.activationService.onSuccess(response),
        (error) => this.activationService.onFail(error),
      );
  }
}
